export const frontendVersion = 'Last Frontend build 2023-06-15T19:46:56+00:00 [ab3355717c60f3884394ed19446aad058f83d322]'
